<div class="form-page">
    <div class="logo-container-left">
        <img class="logo" src="assets/svg-icons/AP7_CX-BM-RGB.svg" alt="Constrcut-X">
    </div>
    <div class="form-container-right">
        <div class="right-container-width">
            <h1 *ngIf="isSpecialInvite === null; else specialInviteTitle" class="title">Registrierung</h1>
            <ng-template #specialInviteTitle>
                <h1 class="title">
                    Willkommen bei Constrcut-X!
                </h1>
            </ng-template>
            <form [formGroup]="registryForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
                <div class="left-column">
                    <div class="columns-25-20-55">
                        <mat-form-field>
                            <mat-label>Anrede</mat-label>
                            <mat-select formControlName="gender">
                                <mat-option *ngFor="let gender of genders" [value]="gender.value">{{ gender.label
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Titel</mat-label>
                            <mat-select formControlName="title">
                                <mat-option *ngFor="let title of titles" [value]="title.value">{{ title.label
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Vorname</mat-label>
                            <input matInput formControlName="firstname" autocomplete="given-name" required
                                (blur)="trimField('firstname')" />
                            <mat-error *ngIf="firstname.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                            <mat-error *ngIf="
                                !firstname.hasError('required') &&
                                firstname.hasError('firstnamelength')
                            ">
                                Der Vorname darf maximal 60 Zeichen lang sein</mat-error>
                            <mat-error *ngIf="
                                !firstname.hasError('required') &&
                                firstname.hasError('firstNameInvalidCharacter')
                            ">Bitte keine Zahlen oder Sonderzeichen</mat-error>
                        </mat-form-field>

                    </div>
                    <mat-form-field>
                        <mat-label>Nachname</mat-label>
                        <input matInput formControlName="lastname" autocomplete="family-name" required
                            (blur)="trimField('lastname')" />
                        <mat-error *ngIf="lastname.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                        <mat-error *ngIf="
                                !lastname.hasError('required') &&
                                lastname.hasError('lastnamelength')
                            ">
                            Der Nachname darf maximal 60 Zeichen lang
                            sein</mat-error>
                        <mat-error *ngIf="
                                !lastname.hasError('required') &&
                                lastname.hasError('lastNameInvalidCharacter')
                            ">Bitte keine Zahlen oder Sonderzeichen</mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="registerWithInvite">
                        <mat-label>Business-E-Mail</mat-label>
                        <input matInput formControlName="email" autocomplete="email" required
                            (blur)="trimField('email')" />
                        <mat-error *ngIf="
                                email.hasError('invalidEmail') &&
                                !email.hasError('required')
                            ">Bitte geben Sie eine valide Business-E-Mail Adresse an</mat-error>
                        <mat-error *ngIf="email.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="!registerWithInvite">
                        <mat-label>Business-E-Mail</mat-label>
                        <input matInput formControlName="email" autocomplete="email" required
                            (blur)="trimField('email')" />
                        <mat-error *ngIf="
                                email.hasError('invalidEmail') &&
                                !email.hasError('required')
                            ">Bitte geben Sie eine valide Business-E-Mail Adresse an</mat-error>
                        <mat-error *ngIf="email.hasError('required')">Diese Angabe ist erforderlich</mat-error>
                    </mat-form-field>
                    <!-- <mat-form-field>
                        <input matInput placeholder="Telefonnummer" formControlName="phoneNumber" autocomplete="tel"
                            (blur)="checkAndSetPhonenumber()" />
                        <mat-error *ngIf="phoneNumber.invalid">
                            Bitte geben Sie eine gültige Telefonnummer ein</mat-error>
                    </mat-form-field> -->
                    <!-- <mat-form-field>
                        <input
                            matInput
                            placeholder="URL"
                            [formControl]="website"
                            autocomplete="url"
                        />
                        <mat-error *ngIf="website.hasError('websiteLength')">
                            Die URL darf maximal 60 Zeichen lang sein</mat-error
                        >
                    </mat-form-field> -->
                    <!-- <mat-form-field>
                        <input
                            matInput
                            placeholder="Position"
                            [formControl]="position"
                            autocomplete="position"
                        />
                        <mat-error *ngIf="position.hasError('positionLength')">
                            Die Position darf maximal 60 Zeichen lang
                            sein</mat-error
                        >
                        <mat-error
                            *ngIf="position.hasError('positionInvalidCharacter')"
                            >Bitte keine Zahlen oder Sonderzeichen</mat-error
                        >
                    </mat-form-field> -->
                    <div #passwordField>
                        <mat-form-field class="password-field">
                            <mat-label>Passwort</mat-label>
                            <input matInput formControlName="password" autocomplete="new-password"
                                [type]="showPassword ? 'text' : 'password'" required
                                (input)="checkPasswordStrength(password.value)" (focus)="passwordTouched = true" />
                            <button class="visibility-btn" matSuffix (click)="showPassword = !showPassword"
                                [attr.aria-label]="'Passwort anzeigen/verbergen'" [attr.aria-pressed]="showPassword"
                                type="button">
                                <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'">
                                </div>
                            </button>
                            <!-- <mat-error *ngIf="password.hasError('required')">
                                Diese Angabe ist erforderlich
                            </mat-error> -->
                        </mat-form-field>
                        <div class="pw-grafic-con">
                            <div class="pw-element" [class]="getStrengthBarClass(1)"></div>
                            <div class="pw-element" [class]="getStrengthBarClass(2)"></div>
                            <div class="pw-element" [class]="getStrengthBarClass(3)"></div>
                            <span class="strength-txt"
                                [class]="{'strength-txt-var(--app-warn)': passwordStrength < 3, 'strength-txt-var(--app-accent)': passwordStrength < 6 && passwordStrength >= 3, 'strength-txt-var(--app-primary)': passwordStrength >= 6 }">{{
                                getStrengthLabel() }}</span>
                        </div>
                        <!-- <div
                            *ngIf="arePasswordRulesVisible"
                            class="password-rules-container"
                        >
                            <div class="password-rules">
                                <p class="password-header">Das Passwort muss:</p>
                                <ul>
                                    <li
                                        [class]="{
                                            error: password.hasError(
                                                'passwordlength'
                                            )
                                        }"
                                    >
                                        mindestens 6 Zeichen lang sein
                                    </li>
                                    <li
                                        [class]="{
                                            error: password.hasError(
                                                'passwordSpecialChar'
                                            )
                                        }"
                                    >
                                        mindestens ein Sonderzeichen beinhalten
                                    </li>
                                    <li
                                        [class]="{
                                            error: password.hasError(
                                                'passwordNumber'
                                            )
                                        }"
                                    >
                                        mindestens eine Zahl beinhalten
                                    </li>
                                    <li
                                        [class]="{
                                            error: password.hasError(
                                                'passwordContainsWhitespace'
                                            )
                                        }"
                                    >
                                        kein Leerzeichen beinhalten
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                    <div>
                        <div class="dis-flx align-cen" *ngIf="passwordTouched && passwordStrength < 6">
                            <div class="alert-icon"></div>
                            <span class="alert-txt">Ihr Passwort muss mindestens 12 Zeichen, Groß- und Kleinbuchstaben,
                                eine Zahl und ein Sonderzeichen enthalten.</span>
                        </div>
                    </div>
                    <div #passwordFieldConfirm>
                        <mat-form-field class="password-field">
                            <mat-label>Passwort wiederholen</mat-label>
                            <input matInput formControlName="confirmpassword" autocomplete="new-password"
                                [type]="showPassword ? 'text' : 'password'" [errorStateMatcher]="matcher" required />
                            <button class="visibility-btn" matSuffix (click)="showPassword = !showPassword"
                                [attr.aria-label]="'Passwort anzeigen/verbergen'" [attr.aria-pressed]="showPassword"
                                type="button">
                                <div class="visibility-icon" [class]="showPassword? 'visibility_off' : 'visibility'">
                                </div>
                            </button>
                            <mat-error *ngIf="registryForm.hasError('notEqual')">Diese Angabe stimmt nicht mit dem
                                Passwort überein
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div></div>
                    <!-- <app-password-strength
                        [password]="password.value"
                    ></app-password-strength> -->
                </div>
                <div class="checkbox-container">
                    <div *ngIf="isSpecialInvite === true || isSpecialInvite === false" class="checkbox-row">
                        <mat-checkbox formControlName="terms3Accepted" class="example-margin">
                        </mat-checkbox>
                        <span *ngIf="isSpecialInvite === true">
                            Ich stimme der Übertragung meines bestehenden Vertrages wie <a
                                (click)="showContractTransfer()">hier</a> beschrieben zu. *
                        </span>
                        <span *ngIf="isSpecialInvite === false">
                            Ich nehme die Einladung an und möchte der Organisation beitreten. *
                        </span>
                    </div>
                    <div class="checkbox-row">
                        <mat-checkbox formControlName="terms2Accepted" class="example-margin">
                        </mat-checkbox>
                        <span>
                            Hiermit bestätige ich, dass ich mich als Geschäftskunde registriere. *
                        </span>
                    </div>
                    <div class="checkbox-row">
                        <mat-checkbox formControlName="termsAccepted" class="example-margin">
                        </mat-checkbox>
                        <span>
                            Ich habe die <a (click)="showAgb()">AGB</a> gelesen und stimme zu. *
                        </span>
                    </div>
                    <span class="privacy-span">
                        Ich habe die <a (click)="showPrivacy()">Datenschutzerklärung</a> zur Kenntnis genommen.
                    </span>
                    <div>
                        <mat-error class="checkbox-error" *ngIf="(registryForm.get('termsAccepted')?.hasError('required') || registryForm.get('termsAccepted')?.hasError('requiredTrue')) 
                        && (registryForm.get('termsAccepted')?.touched || registerClicked)">
                            Sie müssen den Bedingungen zustimmen
                        </mat-error>
                    </div>
                </div>
                <div class="form-btn-container">
                    <span class="info-txt">*Pflichtfeld</span>
                    <div>
                        <button matButton="elevated" color="warn" (click)="onCancel()">
                            Abbrechen
                        </button>
                        <button matButton="elevated" class="green-confirm" type="submit"
                            [disabled]="registryForm.invalid || registerClicked">
                            Registrieren
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div *ngIf="loading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>
